import { jsx as _jsx } from "react/jsx-runtime";
import { ListItemButton as MuiListItemButton, } from '@mui/material';
import { styled } from '../../utils';
export function ListItemButton({ noMargin, ...props }) {
    return _jsx(ListItemButtonStyled, { noMargin: noMargin, ...props });
}
const ListItemButtonStyled = styled(MuiListItemButton, {
    shouldForwardProp: (prop) => prop !== 'noMargin',
})(({ theme, noMargin }) => ({
    padding: theme.spacing(1, 1.5),
    margin: noMargin ? theme.spacing(0) : theme.spacing(1, 0),
    color: theme.palette.secondary.dark,
    ...theme.typography.body1,
    '&.Mui-selected': {
        '&::before': {
            content: '""',
            height: '100%',
            width: '1px',
            backgroundColor: theme.palette.primary.lighter,
            position: 'absolute',
            left: 0,
        },
        color: theme.palette.primary.dark,
        backgroundColor: theme.palette.groupPrimary.zurichAzure,
        '&:hover': { backgroundColor: theme.palette.groupPrimary.zurichAzure },
    },
    '&:hover, &:focus': {
        backgroundColor: theme.palette.groupPrimary.zurichAzure,
    },
    '&:active .MuiTouchRipple-root': {
        color: theme.palette.primary.dark,
    },
}));
